import useLazySelector, { useLazyLoader } from "common/redux/useLazySelector";
import * as MerchantActions from 'features/merchants/merchants.actions';
import { CustomField } from "domain/customField";
import IsLoaded from "common/isLoaded";

const defaultVal: CustomField[] = [];
export default function useCustomFields(): CustomField[] {
    return useLazySelector(store => store.customFields, MerchantActions.loadMerchantCustomFields, null, defaultVal);
}

export function useCustomFieldsLoader(): IsLoaded<CustomField[]> {
    return useLazyLoader(store => store.customFields, MerchantActions.loadMerchantCustomFields, null, defaultVal);
}